import { cn } from '@/lib/utils';

type CardHeaderProps = React.ComponentProps<'div'>;

export const CardHeader = ({ className, ...props }: CardHeaderProps) => (
  <div
    data-slot="card-header"
    className={cn(
      'tw-gap-1 tw-rounded-t-xl tw-px-4 group-data-[size=sm]/card:tw-px-3 [.border-b]:tw-pb-4 group-data-[size=sm]/card:[.border-b]:tw-pb-3 group/card-header @container/card-header tw-grid tw-auto-rows-min tw-items-start has-data-[slot=card-action]:tw-grid-cols-[1fr_auto] has-data-[slot=card-description]:tw-grid-rows-[auto_auto]',
      className,
    )}
    {...props}
  />
);
